import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { initAxios } from 'utils';
import axios from 'axios';
import { loadProfile } from 'actions/profile';
import App from './containers/App/App';
import 'normalize.css';
import './assets/fonts/stylesheet.css';
import './assets/fonts/cera-pro/stylesheet.css';
import './assets/styles/style.css';

import runtime from 'offline-plugin/runtime';
import { Helmet } from 'react-helmet';
import i18n from './i18n';

runtime.install({
  onInstalled: () => {
    console.log('SW Event:', 'onInstalled');
  },
  onUpdating: () => {
    console.log('SW Event:', 'onUpdating');
  },
  onUpdateReady: () => {
    console.log('SW Event:', 'onUpdateReady');
    // Tells to new SW to take control immediately
    runtime.applyUpdate();
  },
  onUpdated: () => {
    console.log('SW Event:', 'onUpdated');
    // Reload the webpage to load into the new version
    window.location.reload();
  },

  onUpdateFailed: () => {
    console.log('SW Event:', 'onUpdateFailed');
  },
});

if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

export const store = configureStore();

let token = '';
try {
  token = localStorage.getItem('token');
} catch (e) {}

initAxios(token);

axios.interceptors.request.use(
  (config) => {
    let token = '';
    let lang = 'ru';

    try {
      token = localStorage.getItem('token');
      lang = localStorage.getItem('lang') || 'ru';
    } catch (e) {}
    config.headers = { 'x-api-token': token, 'Accept-Language': lang };

    if (token && axios.defaults.headers.common['x-api-token'] !== token) {
      initAxios(token);
      store.dispatch(loadProfile());
    }
    return config;
  },
  (error) => Promise.reject(error)
);

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <Helmet>
        <title>{i18n.t('common.title')}</title>
      </Helmet>
      <Router basename="">
        <App />
      </Router>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js